import * as React from 'react';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import Metadata from '@om-fe/core/components/metadata/metadata';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { MatchContentTabs } from '../components/match-content-tabs/match-content-tabs';
import SportsBanner from '@om-fe/core/components/external-widgets/sports-banner';
import getConfig, { BannerMatrixConfig, OMFE2ConfigModel } from '@om-fe/core/utils/config';
import BannermatrixBanner from '@om-fe/core/components/external-widgets/bannermatrix-banner';
import { setVirtualStateAction } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import { withSelectionBetslipData, WithSelectionBetslipDataModel } from '@om-fe/widgets/dist/widgets/betslip/with-betslip-selection-data/with-betslip-selection-data';
import { DeepLink } from '@om-fe/core/utils/deep-link';
import CheckdMediaWidget, { CheckdMediaErrorBoundary } from '@om-fe/core/components/external-widgets/checkd-media-widget';
import JackpotBanner from '@om-fe/core/components/jackpot/jackpot-banner';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';
import BreakpointWrapper from '@om-fe/core/components/breakpoint-wrapper/breakpoint-wrapper';

export type HomeProps = RouteComponentProps<{
    readonly bettingOfferIds?: string;
    readonly stake?: string;
}> & I18nContextInterface & WithSelectionBetslipDataModel;

const globalConfig: OMFE2ConfigModel = getConfig();
const bannerMatrixConfig: BannerMatrixConfig | undefined = globalConfig.bannerMatrix;
const jackpotEnabled: boolean = !!globalConfig.jackpot?.enabled;
const centerMainSliderHeight = bannerMatrixConfig?.height?.['center-main-slider'] || '140px';

class HomeComponent extends React.Component<HomeProps> {
    constructor(props: HomeProps) {
        super(props);
        setVirtualStateAction(false);
    }

    componentDidMount() {
        const { match: { params: { bettingOfferIds, stake } }, addSelection, setMasterStake, setSingleSelectionStake } = this.props;
        DeepLink({ bettingOfferIds, stake, id: undefined, addSelection, setSingleSelectionStake, setMasterStake });
    }

    renderBanner = (): React.ReactNode => {
        if (bannerMatrixConfig) {
            return (
                <>
                    <div className="BannerWidgetWrapper" style={{ height: centerMainSliderHeight }}>
                        <BannermatrixBanner
                            className="BannerWidgetMainSlider BannerWidgetColorPack"
                            pageTag="home-page"
                            positionTag="center-main-slider"
                            height={centerMainSliderHeight}
                        />
                    </div>
                    {bannerMatrixConfig.showOnUnderMainSlider && (
                        <div className="BannerWidgetWrapper2">
                            <BannermatrixBanner
                                className="BannerWidgetUnderMainSlider BannerWidgetColorPack"
                                pageTag="home-page"
                                positionTag="center-under-main-slider"
                                height={bannerMatrixConfig.height?.['center-under-main-slider']}
                            />
                        </div>
                    )}
                </>
            );
        }

        return (
            <SportsBanner />
        );
    }

    render() {
        const { gettext } = this.props;

        const metadataText: string = gettext('Sports Betting');

        return (
            <>
                <Metadata
                    title={metadataText}
                    keywords={metadataText}
                    description={metadataText}
                />
                {this.renderBanner()}
                <CheckdMediaErrorBoundary>
                    <CheckdMediaWidget className="CheckdMediaAboveNav" />
                </CheckdMediaErrorBoundary>
                {jackpotEnabled && (
                    <BreakpointWrapper breakpoints={[Breakpoints.Small]}>
                        <JackpotBanner />
                    </BreakpointWrapper>
                )}
                <MatchContentTabs />
                {bannerMatrixConfig?.showOnFooter && (
                    <div id="BannerFooter" className="BannerWidgetBannerHidden">
                        <BannermatrixBanner
                            className="BannerWidgetAboveFooter1 BannerWidgetColorPack"
                            positionTag="center-above-footer-1"
                        />
                        <BannermatrixBanner
                            className="BannerWidgetAboveFooter2 BannerWidgetColorPack"
                            positionTag="center-above-footer-2"
                        />
                    </div>
                )}
            </>
        );
    }
}

const Home: React.ComponentType<{}> = compose(
    withSelectionBetslipData<HomeProps>(),
    withTranslation<{}>(),
)(HomeComponent);
export default Home;
